/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetOrdersQueryResponse, GetOrdersQueryParams, GetOrders400 } from "../entities/GetOrders";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getOrders } from "../api/getOrders";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOrdersQueryKey = (params: GetOrdersQueryParams) => [{ url: '/orders' }, ...(params ? [params] : [])] as const

export type GetOrdersQueryKey = ReturnType<typeof getOrdersQueryKey>

export function getOrdersQueryOptions(params: GetOrdersQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getOrdersQueryKey(params)
  return queryOptions<GetOrdersQueryResponse, ResponseErrorConfig<GetOrders400>, GetOrdersQueryResponse, typeof queryKey>({
   enabled: !!(params),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return getOrders(params, config)
   },
  })
}

/**
 * @description Получение списка заказов
 * @summary Получение списка заказов
 * {@link /orders}
 */
export function useGetOrders<TData = GetOrdersQueryResponse, TQueryData = GetOrdersQueryResponse, TQueryKey extends QueryKey = GetOrdersQueryKey>(params: GetOrdersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetOrdersQueryResponse, ResponseErrorConfig<GetOrders400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getOrdersQueryKey(params)

  const query = useQuery({
   ...getOrdersQueryOptions(params, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetOrders400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}